import { render } from "./AppPanelMenuSub.vue?vue&type=template&id=07681eaa"
import script from "./AppPanelMenuSub.vue?vue&type=script&lang=js"
export * from "./AppPanelMenuSub.vue?vue&type=script&lang=js"

import exportComponent from "/data/www/shoptok-analytics/frontend/live/live_225/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__